import { useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Toast from 'react-bootstrap/Toast';
import warningIcon from '../../logo/warning.png';

/**
 * Port of `commonComponents/popOverForTimeValidation.jsx` — the "hours are under 24"
 * bubble anchored to the offending time input.
 *
 * Two oddities of the original are preserved because they are load-bearing for how it
 * renders: the anchor is a `<text>` element (an SVG tag used in HTML, which the browser
 * treats as an unknown inline element — it is invisible, which is the point), and
 * `showPopover` starts false and is set true on mount, so the bubble animates in rather
 * than appearing with the first paint.
 *
 * Dropped: the unused `Button`/`Popover` imports, and the `overlayStyle` prop, which
 * OverlayTrigger does not accept and React therefore never applied.
 */
export function PopOverForTimeValidation(): JSX.Element {
  const [showPopover, setShowPopover] = useState(false);

  useEffect(() => {
    setShowPopover(true);
  }, []);

  const popOverForTimeValidation = (
    <Toast id="timeValidation" className="">
      <Toast.Body
        className="time-validation"
        style={{
          background: 'rgb(48 119 187)',
          color: '#fff',
          border: '1px solid rgb(48 119 187)',
          borderRadius: '5px',
          padding: '5px',
          fontSize: '11px',
        }}
      >
        <img src={warningIcon} style={{ width: '25px', height: '25px', padding: '2px' }} />

        <span className="" style={{ paddingLeft: '5px' }}>
          Hmm, this doesn't look right. Make sure hours are under 24
        </span>
      </Toast.Body>
    </Toast>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement="top"
      overlay={popOverForTimeValidation}
      show={showPopover}
    >
      <text />
    </OverlayTrigger>
  );
}
